import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/job-titles')({
  staticData: { breadcrumb: 'Job Titles', breadcrumbKey: 'K_BREADCRUMB_JOB_TITLES' },
});
